module.exports = __webpack_public_path__ + "static/img/footer.cf0a084.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/footer.png
// module id = WB99
// module chunks = 1